import { render, staticRenderFns } from "./BoMembers.vue?vue&type=template&id=dba60ee2&"
import script from "./BoMembers.vue?vue&type=script&lang=js&"
export * from "./BoMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports